import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={13} fill="none" ref={ref} {...props}>
    <g clipPath="url(#clip0_4402_105108)">
      <path
        d="M0.892578 7.45204L5.60051 1.99084C5.94244 1.5942 6.557 1.5942 6.89893 1.99084L11.6069 7.45204"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.54117 5.54367L5.59955 1.98052C5.9416 1.58201 6.55833 1.58201 6.90037 1.98052L9.95875 5.54367L10.1334 6.7899C10.2909 7.91292 10.2832 9.05292 10.1105 10.1737C10.0232 10.7409 9.53515 11.1595 8.96138 11.1595H3.53858C2.96474 11.1595 2.47671 10.7409 2.38937 10.1737C2.21678 9.05292 2.20906 7.91292 2.36649 6.7899L2.54117 5.54367Z"
        fill="white"
        stroke="#383838"
        strokeLinejoin="round"
      />
      <path
        d="M6.24969 7.125C7.03912 7.125 7.67907 7.76495 7.67907 8.55438V11.16H4.82031V8.55438C4.82031 7.76495 5.46027 7.125 6.24969 7.125Z"
        fill="white"
        stroke="#383838"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4402_105108">
        <rect width="12" height="12" fill="white" transform="translate(0.25 0.191406)" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconHouse = memo(ForwardRef);
export default IconHouse;
